module.exports = {
  "zones": {
    "Europe/Warsaw": ["z", {
      "wallclock": 567993600000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": 567990000000,
      "save": 0,
      "rules": "EU"
    }, {
      "wallclock": 220924800000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": 220921200000,
      "save": 0,
      "rules": "W-Eur"
    }, {
      "wallclock": -796867200000,
      "format": "CE%sT",
      "abbrev": "CEST",
      "offset": 3600000,
      "posix": -796874400000,
      "save": 3600000,
      "rules": "Poland"
    }, {
      "wallclock": -931730400000,
      "format": "CE%sT",
      "abbrev": "CEST",
      "offset": 3600000,
      "posix": -931734000000,
      "save": 3600000,
      "rules": "C-Eur"
    }, {
      "wallclock": -1501718400000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": -1501725600000,
      "save": 0,
      "rules": "Poland"
    }, {
      "wallclock": -1618693200000,
      "format": "EE%sT",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": -1618700400000,
      "save": 0,
      "rules": "Poland"
    }, {
      "wallclock": -1717027200000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": -1717032240000,
      "save": 0,
      "rules": "C-Eur"
    }, {
      "wallclock": -2840140800000,
      "format": "WMT",
      "abbrev": "WMT",
      "offset": 5040000,
      "posix": -2840145840000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 5040000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "EU": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1985,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1984,
      "to": 1984,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1982,
      "to": 1983,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1981,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1979,
      "to": 1980,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }],
    "W-Eur": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 60,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1979,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }],
    "Poland": [{
      "from": 1961,
      "to": 1964,
      "month": 4,
      "day": [0, -31],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1962,
      "to": 1964,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1959,
      "to": 1961,
      "month": 9,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1960,
      "to": 1960,
      "month": 3,
      "day": [7, 3],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1959,
      "to": 1959,
      "month": 4,
      "day": [7, 31],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1957,
      "to": 1958,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1958,
      "to": 1958,
      "month": 2,
      "day": [7, 30],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1957,
      "to": 1957,
      "month": 5,
      "day": [7, 2],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1947,
      "to": 1949,
      "month": 9,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1949,
      "to": 1949,
      "month": 3,
      "day": [7, 10],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1948,
      "to": 1948,
      "month": 3,
      "day": [7, 18],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1947,
      "to": 1947,
      "month": 4,
      "day": [7, 4],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1946,
      "to": 1946,
      "month": 3,
      "day": [7, 14],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1946,
      "to": 1946,
      "month": 9,
      "day": [7, 7],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 3,
      "day": [7, 29],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 10,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1944,
      "to": 1944,
      "month": 3,
      "day": [7, 3],
      "time": 120,
      "clock": "standard",
      "save": 60,
      "letter": "S"
    }, {
      "from": 1944,
      "to": 1944,
      "month": 9,
      "day": [7, 4],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1918,
      "to": 1919,
      "month": 8,
      "day": [7, 16],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1919,
      "to": 1919,
      "month": 3,
      "day": [7, 15],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }],
    "C-Eur": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1979,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "standard",
      "save": 60,
      "letter": "S"
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 120,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1944,
      "to": 1945,
      "month": 3,
      "day": [1, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [7, 16],
      "time": 120,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1944,
      "to": 1944,
      "month": 9,
      "day": [7, 2],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1943,
      "to": 1943,
      "month": 2,
      "day": [7, 29],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1943,
      "to": 1943,
      "month": 9,
      "day": [7, 4],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 10,
      "day": [7, 2],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1940,
      "to": 1940,
      "month": 3,
      "day": [7, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1918,
      "month": 3,
      "day": [1, 15],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1918,
      "month": 8,
      "day": [1, 15],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1916,
      "to": 1916,
      "month": 3,
      "day": [7, 30],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1916,
      "to": 1916,
      "month": 9,
      "day": [7, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};